
import {
  defineComponent,
  ref,
  useContext,
  useRouter,
} from '@nuxtjs/composition-api'
import elementButton from '~/components/element/elementButton.vue'

export default defineComponent({
  components: {
    elementButton,
  },
  props: {
    searchForm: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      app: { localePath },
    } = useContext()

    const router = useRouter()

    const searchTerm = ref('' as string)
    const search = async (event: any) => {
      if (event) {
        event.preventDefault()
      }
      if (props) {
        searchTerm.value = searchTerm.value.trim().toUpperCase()
        if (
          searchTerm.value !== '' &&
          (searchTerm.value.match(/^[A-Z]-[0-9]{4}-[0-9]+$/) ||
            searchTerm.value.match(/^[A-Z]-[A-Z0-9]{3,}-[A-Z0-9]+$/) ||
            searchTerm.value.match(/^[A-Z]-[A-Z0-9]{3,}-[A-Z0-9]+-[A-Z0-9]+$/))
        ) {
          await router.push({
            path: localePath({ name: 'configurator' }) + '#' + searchTerm.value,
          })

          emit('update:searchForm', false)

          router.afterEach(() => {
            location.reload()
          })
        }
      }
    }

    return {
      searchTerm,
      search,
    }
  },
})
